"use strict";
// Copyright © 2022 Move Closer
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerSanitize = void 0;
const vue_sanitize_1 = __importDefault(require("vue-sanitize"));
// sanitize config options
const sanitizeOptions = {
    allowedTags: [
        'a',
        'br',
        'span'
    ],
    allowedAttributes: {
        a: ['href', 'target', 'style'],
        br: ['style'],
        span: ['style']
    }
};
exports.registerSanitize = (Vue) => {
    Vue.use(vue_sanitize_1.default, sanitizeOptions);
};
//# sourceMappingURL=sanitize.js.map